import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findCampaignsByUserId2, findUserByUsername } from 'components/graphql/queries'
import React, { useEffect, useState } from 'react'
import Moment from 'react-moment'
import { ClipLoader } from 'react-spinners';
import { Card, CardBody, CardImg, CardSubtitle, Col, Row } from 'reactstrap';
import Description from '../CampaignsDashboard/Description'

const ShowcaseCampaigns: React.FC<{ [label: string]: any }> = (props: any) => {

    const [username] = useState(props.match.params.username)
    const [error, setError] = useState(false)
    const [user, setUser] = useState({
        name: '', email: '', lastname: '', avatar: '', id: ''
    })
    const [loading, setLoading] = useState(true)
    const [campaigns, setCampaigns] = useState([])
    const contentImagesDivider = '-CONTENT-IMAGES-DIVIDER-'
    const imageUrlsDivider = '-IMAGE-LINKS-DIVIDER-'

    interface ICampaignDescription {
        content: string
        imageUrls: string[]
    }

    const splitDescription = (campaignDescription: string): ICampaignDescription => {
        const arr = campaignDescription.split(contentImagesDivider)
        return {
            content: arr[0],
            imageUrls: arr.length > 1
                ? arr[1].split(imageUrlsDivider)
                : []
        }
    }

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findUserByUsername,
                variables: {
                    username
                }
            })
            .then((res: any) => {
                if (res.data.data.user.findByUsername) {
                    const userObject = res.data.data.user.findByUsername
                    setUser(userObject)
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: findCampaignsByUserId2,
                            variables: {
                                userId: userObject.id
                            }
                        })
                        .then(res2 => {
                            setCampaigns(res2.data.data.campaign.findByUserId)
                            setLoading(false)
                        })
                        .catch(err => {
                            setError(true)
                            setLoading(false)
                        })
                } else {
                    setError(true)
                    setLoading(false)
                }
            })
            .catch((err) => {
                setError(true)
                setLoading(false)
            })
    }, [username, setUser, setCampaigns])

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="w-100 text-center" style={{ paddingTop: '100px' }}>
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    if (error || !user) {
        return <div style={{ paddingTop: '100px' }}>
            <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                <strong>
                    Page not found<br />
                    <small>Contact info@isotopeticketing.com for more info.</small><br /><br />
                </strong>
            </h6>
        </div>
    }

    let activeCount = 0;
    campaigns.map((item: any) => {
        if (item.isActive) {
            activeCount++;
        }
    })

    return <div style={{ textAlign: 'center' }}>
        {/* <a href='https://www.isotopeticketing.com' target='_blank' style={{ cursor: 'pointer' }}>
            <img src={require('../../auth/login/components/login-form/Dark-logo.png')} style={{ width: '120px', marginBottom: '20px' }} />
        </a> */}
        {/* <h1 style={{ marginBottom: '20px' }}>
            Get Tickets
        </h1> */}
        <br />
        {
            user.avatar && user.avatar !== '' ?

                <img src={user.avatar} width='80px' height='80px' style={{
                    objectFit: 'cover',
                    borderRadius: '30px',
                    marginBottom: '20px'
                }} />
                : null
        }
        <p style={{ fontWeight: 'bold', fontSize: '15px' }}>
            Invited By{' ' + user.name + ' ' + user.lastname}
        </p>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', marginTop: '25px' }}>
            {
                activeCount === 0 ?
                    <h6 className='gray-text' style={{ width: '100%', textAlign: 'center' }}>
                        Currently not Selling.
                    </h6> :
                    campaigns.map((campaign: any) => {
                        if (!campaign.isActive) {
                            return null
                        }
                        return (
                            <div style={{
                                marginRight: '20px',
                                marginLeft: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                textAlign: 'left'
                            }} key={campaign.id}>
                                <a
                                    href={
                                        user.id.toString().trim() === campaign.createdBy.toString().trim() ?
                                            'https://' + campaign.subdomain + '.isotopeticketing.com' :
                                            'https://' + campaign.subdomain + '.isotopeticketing.com/' + username
                                    }
                                    target='_blank'
                                    style={{ textDecoration: 'none', width: '500px', }}
                                >
                                    <Card
                                        style={{
                                            width: '100%',
                                            cursor: 'pointer',
                                            marginBottom: '45px',
                                            borderRadius: '20px',
                                            maxWidth: '100%'
                                        }}>
                                        <div style={{ height: 'auto', maxHeight: '200px', overflowY: 'hidden' }}>
                                            <CardImg top={true}
                                                src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                                                alt="Event Image"
                                                style={{
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                        <div className="events-page-manage-inside">
                                            <CardBody>
                                                <CardSubtitle >
                                                    <h5 className='cut-text'>
                                                        {campaign.name}
                                                    </h5>
                                                    <p className='gray-text not-bold' style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                                        <Moment format="D MMM 'YY, ">
                                                            {Number(new Date(
                                                                campaign.startTime.year,
                                                                campaign.startTime.month - 1,
                                                                campaign.startTime.day,
                                                                (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                                                campaign.startTime.minute
                                                            ))}
                                                        </Moment>
                                                        <Moment format="hh:mm A">
                                                            {Number(new Date(
                                                                campaign.startTime.year,
                                                                campaign.startTime.month - 1,
                                                                campaign.startTime.day,
                                                                (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                                                campaign.startTime.minute
                                                            ))}
                                                        </Moment>
                                                    </p>
                                                    <Description className='not-bold'>
                                                        {campaign.description.split(contentImagesDivider)[0]}
                                                    </Description>
                                                    {
                                                        splitDescription(campaign.description).imageUrls.length > 0 && <div style={{ width: '100%', display: 'flex', overflowX: 'auto' }}>
                                                            {
                                                                splitDescription(campaign.description).imageUrls.length
                                                                    ? splitDescription(campaign.description).imageUrls.map((src, i) => (
                                                                        <img
                                                                            key={i}
                                                                            src={src}
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '50px',
                                                                                marginBottom: 7,
                                                                                marginRight: 7,
                                                                                borderRadius: 10
                                                                            }}
                                                                        />))
                                                                    : null
                                                            }
                                                        </div>
                                                    }
                                                </CardSubtitle>
                                            </CardBody>
                                        </div>
                                    </Card>
                                </a>
                            </div>)
                    })

            }
        </div>
        <div style={{ height: 'auto', backgroundColor: '#f8f8f8', paddingTop: '100px' }}>
            <div className='container'>
                <Row style={{ textAlign: 'center' }}>
                    <Col style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                        <div className='big-split-768' style={{ width: '100%', display: screen.width >= 768 ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ width: '33%' }}>
                                <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                    <h6 className='gray-text' >
                                        &copy; Isotope Ticketing 2020
                                    </h6>
                                </a>
                            </div>
                            <div style={{ width: '34%' }}>
                                <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                                <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                                <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                            </div>
                            <div style={{ width: '33%' }}>
                                <h6 className='gray-text'>
                                    Powered by Stripe
                                </h6>
                            </div>
                        </div>
                        <div className='small-split-768' style={{ textAlign: 'center' }}>
                            <div style={{ width: '100%' }}>
                                <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                    <h6 className='gray-text' >
                                        &copy; Isotope Ticketing 2020<br /><br />
                                    </h6>
                                </a>
                            </div>
                            <div style={{ width: '100%' }}>
                                <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                                <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                                <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                            </div>
                            <div style={{ width: '100%' }}>
                                <h6 className='gray-text'>
                                    <br />Powered by Stripe
                                </h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div >
}

export default ShowcaseCampaigns;


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsPage/ShowcaseCampaigns.tsx